import React from "react";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../../../Context/AddProWakel";
const FillDetailParawargrtnawakan = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RPW_from, RPW_to, RPW_getPrint } = value;
          return (
            <>
              <div className="row" style={{ backgroundColor: "#2C3539" }}>
                <div className="col-lg-3  col-4 form-inline">
                  <div className="row form-inline">
                    <div className="col-6 form-inline">
                      <p
                        className="font-weight-bold bg-white  f3"
                        style={{ color: "#000" }}
                      ></p>
                      <span style={{ color: "#2C3539" }}>:</span>
                      <p
                        className="font-weight-bold bg-white  f4"
                        style={{ color: "#000" }}
                      >
                        {RPW_to}
                      </p>
                    </div>
                    <div className='col-lg-6 col-6 form-inline"'>
                      <label className=" font-weight-bold f3 text-warning">
                        :بۆ بەرواری{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-4 form-inline">
                  <div className="row form-inline">
                    <div className="col-6 form-inline">
                      <p
                        className="font-weight-bold bg-white  f3"
                        style={{ color: "#000" }}
                      ></p>
                      <span style={{ color: "#2C3539" }}>:</span>
                      <p
                        className="font-weight-bold bg-white  f4"
                        style={{ color: "#000" }}
                      >
                        {RPW_from}
                      </p>
                    </div>
                    <div className='col-lg-6 col-6 form-inline"'>
                      <label className=" font-weight-bold f3 text-warning">
                        :لە بەرواری{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-4 mt3">
                  <div className="row">
                    <div className="col-lg-2 ">
                      <button
                        onClick={RPW_getPrint}
                        className="btn btn-warning"
                      >
                        <Link to="/print-garanawa" className="text-dark">
                          Print
                        </Link>
                      </button>
                    </div>
                    <div className="col-lg-8 col-12">
                      <h3 className="font-weight-bold text-warning">
                        ڕاپۆرتی پارەگەڕاندنەوە
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FillDetailParawargrtnawakan;
